import { render } from "./Signup.vue?vue&type=template&id=2a877c94&scoped=true"
import script from "./Signup.vue?vue&type=script&lang=js"
export * from "./Signup.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-2a877c94"

export default script